import React from 'react';
import { Box, Paper, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

const Section = ({ children, id }) => (
  <Box
    width="100%"
    my={1}
    display="flex"
    justifyContent="center"
    id={id}
    style={{ scrollMarginTop: 24 }}
  >
    <Paper
      style={{
        padding: 32,
        width: '100%',
        maxWidth: 1200,
        backgroundColor: '#ffffff',
      }}
      elevation={1}
    >
      {children}
    </Paper>
  </Box>
);

const SectionTitle = ({ children }) => {
  const theme = useTheme();

  return (
    <Box mb={3}>
      <Typography variant="h4" style={{ fontWeight: 700 }}>
        {children}
      </Typography>
      <Box
        style={{
          width: 48,
          height: 4,
          borderRadius: 2,
          backgroundColor: theme.customColors.brand,
          marginTop: 8,
        }}
      />
    </Box>
  );
};

export { Section, SectionTitle };
